/**
 * *ROLES - All the user roles in our application.
 * *SCOPES - Scopes we pass to our gating wrapper.
 * *PERMISSIONS - The map that defines the set of scopes each user role possesses.
 */



export const ROLES = {
    coordinacionGeneral: "4",
    comercial: "5",
    comercialMatriz: "8",
    cordinadores: "13",
    administracion_finanzas: "19",
    gerenciaOperaciones: "20",
    gerenciaGeneral: "22",
    pruebas: "7",
    adminLocatario: "3",
    operadorLocatario: "2"
};

export const ROLE_NAMES = {
    coordinacionGeneral: "Coordinación General",
    comercial: "Comercial",
    comercialMatriz: "Comercial Matriz",
    cordinadores: "Coordinadores",
    administracion_finanzas: "Administracion y Finanzas",
    gerenciaOperaciones: "Gerencia de Operaciones",
    gerenciaGeneral: "Gerencia General",
    pruebas: "Pruebas",
    adminLocatario: "Administrador Locatario",
    operadorLocatario: "Operador Locatario",
};

export let SCOPES = {
    //Agregar x cada pagina nueva
    GESTION_USUARIOS: "GESTION_USUARIOS",
    GESTION_ROLES: "GESTION_ROLES",
    DASHBOARD_MALL: "DASHBOARD_MALL",
    VENTAS_MENSUAL: "VENTAS_MENSUAL",
    VENTAS_GENERAL: "VENTAS_GENERAL",
    BITACORA_EVENTOS: "BITACORA_EVENTOS",
    LOCATARIOS: "LOCATARIOS",
    ACTUALIZAR_CONTRATOS: "ACTUALIZAR_CONTRATOS",
    GENERAL_VENTAS: "GENERAL_VENTAS",
    VENTAS_PRESUPUESTO: "VENTAS_PRESUPUESTO",
    DIARIO_COMPARATIVO: "DIARIO_COMPARATIVO",
    COMPARATIVO_VENTAS: "COMPARATIVO_VENTAS",
    RANKING_MALL: "RANKING_MALL",
    RANKING_VENTAS: "RANKING_VENTAS",
    EVOLUCION_VENTAS: "EVOLUCION_VENTAS",
    EVOLUCION_VENTAS_TIENDA: "EVOLUCION_VENTAS_TIENDA",
    VENTAS_CATEGORIA: "VENTAS_CATEGORIA",
    VENTAS_LOCATARIOS_M2: "VENTAS_LOCATARIOS_M2",
    VENTAS_POR_DIA: "VENTAS_POR_DIA",
    REPORTE_PROVISION: "REPORTE_PROVISION",
    REPORTE_PROYECCIÓN: "REPORTE_PROYECCIÓN",
    AFLUENCIA_DIARIA_PEATONAL: "AFLUENCIA_DIARIA_PEATONAL",
    AFLUENCIA_MENSUAL_PEATONAL: "AFLUENCIA_MENSUAL_PEATONAL",
    AFLUENCIA_DIARIA_PARKING: "AFLUENCIA_DIARIA_PARKING",
    AFLUENCIA_MENSUAL_PARKING: "AFLUENCIA_MENSUAL_PARKING",
    LISTA_ROJA: "LISTA_ROJA",
    ESTADO_CUENTA: "ESTADO_CUENTA",
    MAPA_CALOR_INDICADOR_VENTAS: "MAPA_CALOR_INDICADOR_VENTAS",
    MAPA_CALOR_REPORTE_CIERRE: "MAPA_CALOR_REPORTE_CIERRE",
    MAPA_CALOR_VACANCY: "MAPA_CALOR_VACANCY",
    MAPA_CALOR_ALL_IN: "MAPA_CALOR_ALL_IN",
    MAPA_CALOR_MANTENIMIENTO: "MAPA_CALOR_MANTENIMIENTO",
    REGISTRO_AMONESTACION: "REGISTRO_AMONESTACION",
    VISTA_AMONESTACIONES: "VISTA_AMONESTACIONES",
    APROBADAS_AMONESTACIONES: "APROBADAS_AMONESTACIONES",
    INFLACION: "INFLACION",
    BLOQUEAR_CIERRES: "BLOQUEAR_CIERRES",
    DASHBOARD_LOCATARIO: "DASHBOARD_LOCATARIO",
    REGISTRAR_CIERRE_VENTA_LOCATARIO: "REGISTRAR_CIERRE_VENTA_LOCATARIO",
    CONSULTA_CIERRE_LOCATARIO: "CONSULTA_CIERRE_LOCATARIO",
    GESTION_USUARIOS_LOCATARIO: "GESTION_USUARIOS_LOCATARIO",
    ESTADO_CUENTA_LOCATARIO: "ESTADO_CUENTA_LOCATARIO",
    GARANTIAS_LOCATARIO: "GARANTIAS_LOCATARIO",
    SUPERADMIN_CONFIG: "SUPERADMIN_CONFIG",
    
    GARANTIAS_REVISION_GARANTIAS: "GARANTIAS_REVISION_GARANTIAS",
    GARANTIAS_REVISION_GARANTIAS_2: "GARANTIAS_REVISION_GARANTIAS_2",
    GARANTIAS_REQUERIMIENTO_CARTA_FIANZA: "GARANTIAS_REQUERIMIENTO_CARTA_FIANZA",
    GARANTIAS_RECEPCION_GARANTIA: "GARANTIAS_RECEPCION_GARANTIA",
    GARANTIAS_UBICACION_CARTA_FIANZA: "GARANTIAS_UBICACION_CARTA_FIANZA",
    GARANTIAS_EXCEPCION_GARANTIA: "GARANTIAS_EXCEPCION_GARANTIA",
    GARANTIAS_DASHBOARD: "GARANTIAS_DASHBOARD",
    GARANTIAS_EDICION: "GARANTIAS_EDICION",
    GARANTIAS_CONFIGURACION: "GARANTIAS_CONFIGURACION",
};

export const MENU_ORDER = {
    //Agregar x cada pagina nueva
    GESTION_USUARIOS: 1,
    GESTION_ROLES: 1,
    DASHBOARD_MALL: 2,
    VENTAS_MENSUAL: 3,
    VENTAS_GENERAL: 4,
    BITACORA_EVENTOS: 5,
    LOCATARIOS: 5,
    ACTUALIZAR_CONTRATOS: 6,
    GENERAL_VENTAS: 7,
    VENTAS_PRESUPUESTO: 8,
    DIARIO_COMPARATIVO: 9,
    COMPARATIVO_VENTAS: 10,
    RANKING_MALL: 11,
    RANKING_VENTAS: 12,
    EVOLUCION_VENTAS: 13,
    EVOLUCION_VENTAS_TIENDA: 14,
    VENTAS_CATEGORIA: 14,
    VENTAS_LOCATARIOS_M2: 15,
    VENTAS_POR_DIA: 16,
    REPORTE_PROVISION: 17,
    REPORTE_PROYECCIÓN: 18,
    AFLUENCIA_DIARIA_PEATONAL: 19,
    AFLUENCIA_MENSUAL_PEATONAL: 20,
    AFLUENCIA_DIARIA_PARKING: 21,
    AFLUENCIA_MENSUAL_PARKING: 22,
    LISTA_ROJA: 23,
    ESTADO_CUENTA: 24,
    MAPA_CALOR_INDICADOR_VENTAS: 25,
    MAPA_CALOR_REPORTE_CIERRE: 26,
    MAPA_CALOR_VACANCY: 27,
    MAPA_CALOR_ALL_IN: 28,
    MAPA_CALOR_MANTENIMIENTO: 29,
    REGISTRO_AMONESTACION: 30,
    VISTA_AMONESTACIONES: 31,
    APROBADAS_AMONESTACIONES: 31,
    INFLACION: 32,
    BLOQUEAR_CIERRES: 33,

    DASHBOARD_LOCATARIO: 34,
    REGISTRAR_CIERRE_VENTA_LOCATARIO: 35,
    CONSULTA_CIERRE_LOCATARIO: 36,
    GESTION_USUARIOS_LOCATARIO: 37,
    ESTADO_CUENTA_LOCATARIO: 38,
};